<template>
  <el-dialog
    title="选择供应商"
    :visible.sync="dialogVisible"
    width="700px"
    height="500px">
    <div>
      <div style="margin-bottom: 40px;">
        <el-row :gutter="24">
          <el-col :span="18">
            <div style="display: flex;">
              <el-input v-model="where.supplier_name" size="mini" placeholder="请输入供应商名称" @keyup.enter.native="searchs"></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <el-button size="mini" type="primary" @click="searchs">搜索</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table
          :data="pageData.list"
          :default-sort = "{}"
          border
          @selection-change="handleSelectionChange"
          style="width: 100%">
          <el-table-column prop="name" label="供应商名称" ></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="selectFun(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
      </div>
    </div>
    <div class="personnel-footer">
      <el-button size="mini" type="info" @click="closeFun">取 消</el-button>
      <!-- <el-button size="mini" type="primary" @click="confirmFun">确 定</el-button> -->
    </div>
  </el-dialog>

</template>

<script>
import Http from "../common/Http";
export default {
  name: "SelectSupplier",
  data(){
    return {
      dialogVisible:false,
      loading:false,
      where:{
        supplier_name:""
      },
      pageData:{
        list:[],
        page:1,
        total:0,
        pageSize:20
      },
      callback_fun:undefined,
    }
  },
  mounted() {
    this.getList();
    // this.getUserRoleList()
  },
  methods:{
    initConfig(){
      this.where = {
        supplier_name:""
      }
      this.pageData = {
        list:[],
        page:1,
        total:0,
        pageSize:20
      };
      this.callback_fun=undefined;
      this.selectData = [];
    },
    /**
     * 显示流程
     */
    show({},callback_fun){
      const that = this;
      that.initConfig();
      that.getList();
      that.dialogVisible=true;
      if(typeof callback_fun === "function"){
        that.callback_fun = callback_fun;
      }
    },
    selectFun(row){
      if(typeof this.callback_fun === "function"){
        this.callback_fun(row);
        this.callback_fun = undefined;
      }
      this.dialogVisible=false;
    },
    confirmFun(){
      if(typeof this.callback_fun === "function"){
        this.callback_fun(this.selectData);
        this.callback_fun = undefined;
      }
      this.dialogVisible=false;
    },
    closeFun(){
      if(typeof this.callback_fun ==="function"){
        this.callback_fun=undefined;
      }
      this.dialogVisible=false;
    },
    getList() {
      const that = this;
      that.loading=true;
      Http.get("https://devshare.gdzawy.com:8091/api/payment-center/ncs/api/v1/e/suppliers/search",{
        keyword:that.where.supplier_name,
      },res=>{
        if(res.code) {
          that.pageData.list = res.data ? res.data.slice(0, 10) : []
          that.pageData.total = res.data.total || 0
          that.pageData.page = res.data.page || 1
          that.pageData.pageSize = res.data.pageSize || 10
        }
        that.loading=false;
      })
    },
    searchs() {
      this.pageData.page = 1
      this.getList()
    },
    pageChange(i) {
      this.pageData.page = i;
      this.getList();
    },
    handleSelectionChange(val) {
      this.selectData = val
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common";
.personnel-footer{
  margin-top: 10px;
  width: 100%;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/SelectSupplier.vue